import { AbstractDialogContent } from '@abstracts/dialog/dialog-content';
import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { CreateDeliveryNoteComponent } from '@components/entities/delivery-notes/create-delivery-note/create-delivery-note.component';
import { TransactionDto } from '@dto/transactionDto';
import { DeliveryNote } from '@models/deliveryNote';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormService } from '@services/form/form.service';
import { ToastService } from '@services/toast/toast.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-create-delivery-note-dialog-content',
  templateUrl: './create-delivery-note-dialog-content.component.html',
  styleUrls: ['./create-delivery-note-dialog-content.component.scss']
})
export class CreateDeliveryNoteDialogContentComponent extends AbstractDialogContent implements OnInit {

  public className = 'CreateDeliveryNoteDialogContentComponent';

  public transactions: TransactionDto[];
  public userId: string;
  public customerId: number;

  @ViewChild('createDeliveryNoteComponent') createDeliveryNoteComponent: CreateDeliveryNoteComponent;

  constructor(
    public activeModal: NgbActiveModal,
    public formService: FormService,
    public toastService: ToastService,
    injector: Injector) {
      super(activeModal, injector);
  }

  ngOnInit() {
  }

  newEntityEvent(deliveryNote: DeliveryNote) {
    this.toastService.success($localize`:@@CreateDeliveryNoteSuccessHeader:Lieferschein erfolgreich gespeichert.`);
    // this.openSuccessDialog();
  }

  openSuccessDialog() {
    Swal.fire({
      title: $localize`:@@CreateDeliveryNoteSuccessHeader:Der Lieferschein wurde generiert!`,
      text: $localize`:@@CreateDeliveryNoteSuccessText:Der neue Lieferschein kann auf der Seite der Lieferscheine heruntergeladen oder per E-Mail versendet werden.`,
      icon: 'success',
      confirmButtonText: $localize`:@@DialogOkButton:OK`,
      confirmButtonColor: 'green'
    });
  }
}
